import React from 'react';
import { useDispatch } from 'react-redux';
import Box from '../../../../components/Box';
import CustomDatePicker from '../../../../components/CustomDatePicker';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import CustomSwitch from '../../../../components/CustomSwitch';
import CustomTextInput from '../../../../components/CustomTextInput';
import { Helpers } from '../../../../helpers/Helpers';
import { storeFastFirm } from '../../../../redux/reducers/authSlice';
import { CompanyService } from '../../../../services/CompanyService';
import { ConstantService } from '../../../../services/ConstantService';
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';

interface Props {
    generalInformationRef: any
    refNo: string | undefined
    name: string | undefined
    setName: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedHeatControlDetail: CustomSingleSelectModel | undefined
    isCustomActive: boolean
    setIsCustomActive: React.Dispatch<React.SetStateAction<boolean>>
    selectedCompany: CustomSingleSelectModel | undefined
    isClosedArea: boolean
    isHeatControllerRoom: boolean
    setSelectedCompany: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    isIncome: boolean
    setIsClosedArea: React.Dispatch<React.SetStateAction<boolean>>
    setSelectedHeatControlDetail: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setIsOpenArea: React.Dispatch<React.SetStateAction<boolean>>
    setIsHeatControllerRoom: React.Dispatch<React.SetStateAction<boolean>>
    isOpenArea: boolean
    startDate: string | undefined
    setIsIncome: React.Dispatch<React.SetStateAction<boolean>>
    selectedProductKind: CustomSingleSelectModel | undefined
    setSelectedProductKind: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setStartDate: React.Dispatch<React.SetStateAction<string | undefined>>
    endDate: string | undefined
    setEndDate: React.Dispatch<React.SetStateAction<string | undefined>>
    isOutcome: boolean
    setIsOutcome: React.Dispatch<React.SetStateAction<boolean>>
}

const GeneralInformation = ({
    generalInformationRef,
    refNo,
    name,
    setName,
    selectedHeatControlDetail,
    isCustomActive,
    setIsCustomActive,
    selectedCompany,
    isClosedArea,
    isHeatControllerRoom,
    setSelectedCompany,
    isIncome,
    setIsClosedArea,
    setSelectedHeatControlDetail,
    setIsOpenArea,
    setIsHeatControllerRoom,
    isOpenArea,
    startDate,
    setIsIncome,
    selectedProductKind,
    setSelectedProductKind,
    endDate,
    setStartDate,
    isOutcome,
    setEndDate,
    setIsOutcome
}: Props) => {
    const dispatch = useDispatch();

    return (
        <div className='containerPart' ref={generalInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                    <div className='row'>
                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Ref No</label>
                                <CustomTextInput value={refNo} isDisabled />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Ad</label>
                                {/* <CustomTextInput value={name} setValue={setName} /> */}
                                <CustomTextInput isDisabled value={!Helpers.isEmpty(name) ? name :
                                    [
                                        selectedCompany?.label,
                                        (isOpenArea ? 'Açık Alan' : isClosedArea ? 'Kapalı Alan' : isHeatControllerRoom ? 'Isı Kontrollü Oda' : ''),
                                        selectedHeatControlDetail?.label,
                                        selectedProductKind?.label?.split('-')[0]?.trim(),
                                    ].filter(x => x && !Helpers.isEmpty(x)).join(' - ')}
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Aktif</label>
                                <CustomSwitch isActive={isCustomActive} setIsActive={setIsCustomActive} />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Kapalı Alan</label>
                                <CustomSwitch isActive={isClosedArea} setIsActive={() => {
                                    setSelectedHeatControlDetail(undefined);
                                    setIsOpenArea(false);
                                    setIsClosedArea(!isClosedArea);
                                    setIsHeatControllerRoom(false);
                                }} />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Müşteri</label>

                                <CustomSingleSelect
                                    selectedValue={selectedCompany}
                                    onChange={(selectedValue) => {
                                        setSelectedCompany(selectedValue);
                                    }}
                                    insertable={{
                                        tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                        onClick: () => {
                                            dispatch(storeFastFirm({
                                                companyId: selectedCompany?.value,
                                                isCustomer: true,
                                                isAgency: true,
                                                isSupplier: true,
                                                onSubmit: async (response) => {
                                                    setSelectedCompany({ label: response.name, value: response.companyId })
                                                },
                                                defaultInitialCompanyTypeId: '1',
                                            }))
                                        }
                                    }}
                                    onMenuOpen={[
                                        () => CompanyService.getCompanyList({ isCustomer: true }),
                                        () => CompanyService.getCompanyList({ isAgency: true }),
                                        () => CompanyService.getCompanyList({ isSupplier: true }),
                                    ]}
                                    labelName='name'
                                    valueName='companyId'
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Ürün Cinsi</label>

                                <CustomSingleSelect
                                    selectedValue={selectedProductKind}
                                    onChange={setSelectedProductKind}
                                    onMenuOpen={() => ConstantService.getConstantList('PRODUCT_KIND', undefined, undefined)}
                                    labelName='value'
                                    valueName='constantId'
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Gelir</label>
                                <CustomSwitch isActive={isIncome} setIsActive={setIsIncome} />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Açık Alan</label>
                                <CustomSwitch isActive={isOpenArea} setIsActive={() => {
                                    setSelectedHeatControlDetail(undefined);
                                    setIsOpenArea(!isOpenArea);
                                    setIsClosedArea(false);
                                    setIsHeatControllerRoom(false);
                                }} />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Başlangıç Tarihi</label>
                                <CustomDatePicker value={startDate} setValue={setStartDate} />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Bitiş Tarihi</label>
                                <CustomDatePicker value={endDate} setValue={setEndDate} />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Gider</label>
                                <CustomSwitch isActive={isOutcome} setIsActive={setIsOutcome} />
                            </div>

                            <Box className="mt-5" flexDirection="row" gap="15px">
                                <Box>
                                    <label htmlFor="exampleFormControlInput1" className="form-label required">Isı Kontrollü Oda</label>

                                    <CustomSwitch isActive={isHeatControllerRoom} setIsActive={() => {
                                        setSelectedHeatControlDetail(undefined);
                                        setIsOpenArea(false);
                                        setIsClosedArea(false);
                                        setIsHeatControllerRoom(!isHeatControllerRoom);
                                    }} />
                                </Box>


                                {
                                    isHeatControllerRoom && (
                                        <Box flexGrow={1}>
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Derece</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedHeatControlDetail}
                                                onChange={setSelectedHeatControlDetail}
                                                onMenuOpen={() => ConstantService.getConstantList('HEAT_CONTROL_DETAIL')}
                                                labelName='value'
                                                valueName='constantId'
                                            />
                                        </Box>
                                    )
                                }
                            </Box>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default GeneralInformation;